export default {"src":"/_next/static/media/bus.d2e6a934.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};